import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { STATICS } from 'statics'
import { Button } from 'components'
import { MODAL_KEYS, ROUTES } from 'app-constants'
import { setModal } from 'slices/modal'
import './style.scss'

const STATUS_KEYS = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
}

const STATUS_DEFINITION = {
  [STATUS_KEYS.SUCCESS]: {
    ICON: <STATICS.CHECK_OUTLINE />,
    TITLE: 'Senha alterada com sucesso!',
    DESCRIPTION:
      'Sua senha foi atualizada com sucesso. Utilize a nova senha sempre que fizer login no aplicativo ou na Central do Assinante.',
  },
  [STATUS_KEYS.ERROR]: {
    ICON: <STATICS.INFO_ERROR_FAQ />,
    TITLE: 'Algo deu errado',
    DESCRIPTION:
      'Tente novamente em alguns minutos ou, se precisar de ajuda, fale com a nossa Central de Atendimento.',
  },
}

export function StatusResponse({ success = false }) {
  const dispatch = useDispatch()
  const status = success
    ? STATUS_DEFINITION[STATUS_KEYS.SUCCESS]
    : STATUS_DEFINITION[STATUS_KEYS.ERROR]

  function handleButtonClick() {
    dispatch(setModal({ key: MODAL_KEYS.NONE }))
  }

  return (
    <div className='required-password-update-status-response'>
      <div className='icon-container'>{status.ICON}</div>
      <h3 className='title'>{status.TITLE}</h3>
      <p className='description'>{status.DESCRIPTION}</p>
      <Link to={ROUTES.HOME.PATH} onClick={handleButtonClick}>
        <Button className='confirm-button' color='primary' onClick={handleButtonClick}>
          ok, entendi!
        </Button>
      </Link>
    </div>
  )
}
